export const isValidEmail = (email, domainCheck = false) => {
  if (domainCheck) {
    return /.@.*\./.test(email);
  }

  return /.@./.test(email);
};

export const maskEmail = email => {
  if (!email) return '';
  const [user, domain] = email.split('@');
  if (user.length <= 2) return email;
  return `${user[0]}${'*'.repeat(5)}${user[user.length - 1]}@${domain}`;
};
